import { IconName } from '@fortawesome/fontawesome-svg-core'

// Maximum number of elements allowed in a single row
export const MAX_ELEMENTS_PER_ROW = 3

// Placeholder element ID used during drag operations
export const PLACEHOLDER_ELEMENT_ID = '__placeholder__'

// Toolbox item type definitions
export interface LayoutToolboxItem {
    id: string
    layoutType: 'row' | 'spacer' | 'list'
    label: string
    icon: IconName
}

export interface ElementToolboxItem {
    id: string
    elementType: string
    label: string
    icon: IconName
}

// Layout items for the toolbox
// Note: 'list' (subform) is a special layout type - it creates a row with a list element inside
export const LAYOUT_ITEMS: LayoutToolboxItem[] = [
    { id: 'toolbox-row', layoutType: 'row', label: 'Row', icon: 'table-rows' },
    { id: 'toolbox-spacer', layoutType: 'spacer', label: 'Spacer', icon: 'arrows-up-down' },
    { id: 'toolbox-list', layoutType: 'list', label: 'Sub Form', icon: 'table-list' }
]

// Form element items for the toolbox
// These match the legacy schemaItemTypes but exclude layout items
export const ELEMENT_ITEMS: ElementToolboxItem[] = [
    { id: 'toolbox-text', elementType: 'text', label: 'Text Input', icon: 'input-text' },
    { id: 'toolbox-dropdown', elementType: 'dropdown', label: 'Dropdown', icon: 'list-dropdown' },
    { id: 'toolbox-checkbox', elementType: 'checkbox', label: 'Checkbox', icon: 'square-check' },
    { id: 'toolbox-date', elementType: 'date', label: 'Date', icon: 'calendar-days' },
    { id: 'toolbox-map', elementType: 'map', label: 'Location/Address/Map', icon: 'location-dot' },
    { id: 'toolbox-user', elementType: 'user', label: 'User Select', icon: 'user' },
    { id: 'toolbox-media', elementType: 'media', label: 'File Upload', icon: 'file-arrow-up' }
]

// Element type display names (for UI labels)
export const ELEMENT_TYPE_LABELS: Record<string, string> = {
    'text': 'Text Input',
    'dropdown': 'Dropdown',
    'checkbox': 'Checkbox',
    'date': 'Date',
    'map': 'Location/Address',
    'user': 'User Select',
    'media': 'File Upload',
    'list': 'Sub Form',
    'spacer': 'Spacer'
}

// Layout type display names
export const LAYOUT_TYPE_LABELS: Record<string, string> = {
    'row': 'Row',
    'spacer': 'Spacer',
    'list': 'Sub Form'
}

// Icons for each type (used in drag overlay and other places)
export const TYPE_ICONS: Record<string, IconName> = {
    'row': 'table-rows',
    'spacer': 'arrows-up-down',
    'list': 'table-list',
    'text': 'input-text',
    'dropdown': 'list-dropdown',
    'checkbox': 'square-check',
    'date': 'calendar-days',
    'map': 'location-dot',
    'user': 'user',
    'media': 'file-arrow-up'
}
